module.exports = __webpack_public_path__ + "media/images/working_icon-5f062c27652550ade12c10cb2cd87ab1.png";